import firebase from 'firebase';
const config = {
    apiKey: "AIzaSyBbuVCHBnNwp6iVKlEnyIYwvn2KPuQ9ZQg",
    authDomain: "crate-6980b.firebaseapp.com",
    databaseURL: "https://crate-6980b.firebaseio.com",
    projectId: "crate-6980b",
    storageBucket: "crate-6980b.appspot.com",
    messagingSenderId: "537141933383"
};
firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js